export interface VimeoVideo {
  videoId: string;
  title: string;
  description: string;
  poster: string;
  duration: number;
  date: string | null;
  tags: VimeoTag[];
  category: string[];
  link: string;
  embedHtml: string;
  downloadUrl: string;
}

export interface VimeoTag {
  value: string;
  title: string;
}

export interface VimeoSearchParams {
  query?: string;
  tags?: string[];
  page?: number;
  per_page?: number;
  folderMap?: string;
}

export interface VimeoApiResponse {
  videos: VimeoVideo[];
  total: number;
  page: number;
  per_page: number;
  totalPages: number;
}

export class VimeoApiClient {
  constructor(private baseUrl: string) {}

  async getVideos(params: VimeoSearchParams = {}): Promise<VimeoApiResponse> {
    const url = new URL(this.baseUrl, window.location.origin);
    url.searchParams.set('type', '1710');
    url.searchParams.set('tx_imosmedialibrary_api[action]', 'videos');

    if (params.query) url.searchParams.set('query', params.query);
    if (params.tags?.length) url.searchParams.set('tags', params.tags.join(','));
    if (params.page) url.searchParams.set('page', String(params.page));
    if (params.per_page) url.searchParams.set('per_page', String(params.per_page));
    if (params.folderMap) url.searchParams.set('folderMap', params.folderMap);

    const response = await fetch(url.toString());
    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }
    return response.json();
  }

  async getTags(): Promise<VimeoTag[]> {
    const url = new URL(this.baseUrl, window.location.origin);
    url.searchParams.set('type', '1710');
    url.searchParams.set('tx_imosmedialibrary_api[action]', 'tags');

    const response = await fetch(url.toString());
    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }
    const data = await response.json();
    return data.tags;
  }
}
